import { Registration } from '@stax-core/types-omni';
import { USD } from '../../../util/currency.util';

const dataCompromisedFields: Partial<Registration['pci_compromise_type']>[] = [
  'NOTIFY_ACTION_DONE',
  'NOTIFY_ACTION_NOT_STARTED',
];

export const isoMapper = (r: Registration) => ({
  min_monthly: r.monthly_minimum_fee ?? '',
  monthly_service: r.monthly_service_fee ?? '',
  datacompromise_no: r.pci_compromise_type === 'NOT_NOTIFY',
  datacompromise_yes: dataCompromisedFields.includes(r.pci_compromise_type),
  completedremediation_no:
    r.pci_compromise_type === 'NOTIFY_ACTION_NOT_STARTED',
  completedremediation_yes: r.pci_compromise_type === 'NOTIFY_ACTION_DONE',
  mastercardvisa_volume:
    USD.parse(r.annual_volume || '0')
      ?.multiply(0.9)
      .format() || '',
  discovernetwork_paypal_volume:
    USD.parse(r.annual_volume || '0')
      ?.multiply(0.05)
      .format() || '',
  amexoptblue_volume:
    USD.parse(r.annual_volume || '0')
      ?.multiply(0.05)
      .format() || '',
});
